import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;

let appInsights = null;

function getStoredUser() {
  try {
    const raw = localStorage.getItem('auth_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

if (connectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
    },
  });
  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((envelope) => {
    const user = getStoredUser();
    if (user) {
      envelope.data = envelope.data || {};
      envelope.data.userId = String(user.id);
      envelope.data.userName = `${user.firstName} ${user.lastName}`.trim();
      envelope.data.userEmail = user.email;
    }
  });

  const initialUser = getStoredUser();
  if (initialUser) {
    appInsights.setAuthenticatedUserContext(String(initialUser.id), null, true);
  }
}

export function setAppInsightsUser(user) {
  if (!appInsights || !user) return;
  appInsights.setAuthenticatedUserContext(String(user.id), null, true);
}

export function clearAppInsightsUser() {
  if (!appInsights) return;
  appInsights.clearAuthenticatedUserContext();
}

export { reactPlugin, appInsights };
